export { default } from '../News/index'
